import { FormHelperText } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { Prompt } from "react-router";
import { harvestYearDetail } from "../../../../../../config/harvestYearDetail";
import Button from "../../../../../FormElement/Button";
import { validForm } from "../../../../../FormElement/FormValidator";
import InputFiled from "../../../../../FormElement/InputFiled";


const history = createBrowserHistory();

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class FieldForm extends Component {
  constructor(props) {
    super(props);
    const { fieldInfo } = props;
    this.state = {
      fieldInfo: {
        id: fieldInfo ? fieldInfo.id : "",
        harvestYear: harvestYearDetail().name,
        name: fieldInfo ? fieldInfo.name : "",
        legalDescription: fieldInfo ? fieldInfo.legalDescription : "",
        owner_one: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[0]
            ? fieldInfo.ownerSplitResponseDTOs[0].ownerName
            : ""
          : "",
        owner_two: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[1]
            ? fieldInfo.ownerSplitResponseDTOs[1].ownerName
            : ""
          : "",
        owner_three: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[2]
            ? fieldInfo.ownerSplitResponseDTOs[2].ownerName
            : ""
          : "",
        owner_four: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[3]
            ? fieldInfo.ownerSplitResponseDTOs[3].ownerName
            : ""
          : "",
        percent_one: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[0]
            ? fieldInfo.ownerSplitResponseDTOs[0].percent
            : ""
          : "",
        percent_two: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[1]
            ? fieldInfo.ownerSplitResponseDTOs[1].percent
            : ""
          : "",
        percent_three: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[2]
            ? fieldInfo.ownerSplitResponseDTOs[2].percent
            : ""
          : "",
        percent_four: fieldInfo
          ? fieldInfo.ownerSplitResponseDTOs[3]
            ? fieldInfo.ownerSplitResponseDTOs[3].percent
            : ""
          : ""
      },
      formErrors: {
        name: ""
      },
      isInvalid: true,
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name.includes("percent_")) {
      if (value.match(/^(\d{0,2}(\.\d{0,2})?|100$)$/)) {
        this.updateState(name, value);
      }
    } else if (name === "name" || name.includes("owner_")) {
      if (value.match(/^(.){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "legalDescription") {
      if (value.match(/^(.|\n){0,256}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  checkSplitPercent = () => {
    const {
      percent_one,
      percent_two,
      percent_three,
      percent_four
    } = this.state.fieldInfo;
    const total =
      (parseFloat(percent_one) || 0) +
      (parseFloat(percent_two) || 0) +
      (parseFloat(percent_three) || 0) +
      (parseFloat(percent_four) || 0);
    return total === 0 || total === 100;
  };

  processData = fieldInfo => {
    const { owner_one, owner_two, owner_three, owner_four } = fieldInfo,
      { percent_one, percent_two, percent_three, percent_four } = fieldInfo;

    const ownerInfo = [
      { ownerName: owner_one, percent: percent_one },
      { ownerName: owner_two, percent: percent_two },
      { ownerName: owner_three, percent: percent_three },
      { ownerName: owner_four, percent: percent_four }
    ];

    const fieldDetails = (({
      fieldGroupId,
      name,
      legalDescription,
      harvestYear
    }) => ({
      fieldGroupId,
      name,
      legalDescription,
      harvestYear
    }))(fieldInfo);

    const ownerSplitRequestDTOs = ownerInfo.filter(
      ({ ownerName, percent }) =>
        ownerName !== "" &&
        ownerName !== undefined &&
        (percent !== "" && percent !== undefined)
    );
    return { ...fieldDetails, ownerSplitRequestDTOs };
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          fieldInfo: {
            ...prevState.fieldInfo,
            [name]: value
          }
        };
      },
      () => {
        const { fieldInfo } = this.state;
        this.setState({
          isInvalid: validForm(this.state.formErrors, { name: fieldInfo.name })
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { fieldInfo } = this.state;
        this.setState({
          isInvalid: validForm(this.state.formErrors, { name: fieldInfo.name })
        });
      }
    );
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true, edited: false });
    const { fieldInfo } = this.state;
    fieldInfo.harvestYear = harvestYearDetail().name;
    const formData = this.processData(fieldInfo);
    formData.id = fieldInfo.id;
    formData.fieldGroupId = localStorage.getItem("currentFieldGrpId");
    this.props.handleSubmit(formData);
  };
  render() {
    const { buttonLabel, formLabel } = this.props;
    const { isInvalid, fieldInfo, edited } = this.state;
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <InputFiled
                label="Field Name"
                value={fieldInfo.name}
                required
                validations={["required", "maxSize"]}
                handleError={this.handleError}
                handleChange={this.handleChange}
                type="text"
                name="name"
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label="Legal Description"
                value={fieldInfo.legalDescription}
                multiline
                rows={2}
                rowsMax={4}
                handleError={this.handleError}
                handleChange={this.handleChange}
                validations={["aboveMaxSize"]}
                type="text"
                name="legalDescription"
              />
            </Grid>
            <Grid item xs={12}>
              <label>Production Split(s)</label>
            </Grid>
            <FormHelperText style={{ color: "blue", marginLeft: "5px" }}>
              Owner info will be saved only when spilt% is assigned to owner.
            </FormHelperText>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Owner name"
                value={fieldInfo.owner_one}
                handleChange={this.handleChange}
                type="text"
                name="owner_one"
                validations={
                  fieldInfo.percent_one ? ["required", "maxSize"] : ["maxSize"]
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Split %"
                value={fieldInfo.percent_one}
                disabled={!fieldInfo.owner_one}
                //validations={fieldInfo.owner_one ? ["required"] : []}
                handleError={this.handleError}
                handleChange={this.handleChange}
                type="text"
                name="percent_one"
              />
            </Grid>

            <Grid item xs={6}>
              <InputFiled
                placeholder="Owner name"
                value={fieldInfo.owner_two}
                handleChange={this.handleChange}
                type="text"
                name="owner_two"
                validations={
                  fieldInfo.percent_two ? ["required", "maxSize"] : ["maxSize"]
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Split %"
                value={fieldInfo.percent_two}
                disabled={!fieldInfo.owner_two}
                //validations={fieldInfo.owner_two ? ["required"] : []}
                handleError={this.handleError}
                handleChange={this.handleChange}
                type="text"
                name="percent_two"
              />
            </Grid>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Owner name"
                value={fieldInfo.owner_three}
                handleChange={this.handleChange}
                type="text"
                name="owner_three"
                validations={["maxSize"]}
                validations={
                  fieldInfo.percent_three
                    ? ["required", "maxSize"]
                    : ["maxSize"]
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Split %"
                value={fieldInfo.percent_three}
                disabled={!fieldInfo.owner_three}
                //validations={fieldInfo.owner_three ? ["required"] : []}
                handleError={this.handleError}
                handleChange={this.handleChange}
                type="text"
                name="percent_three"
              />
            </Grid>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Owner name"
                value={fieldInfo.owner_four}
                handleChange={this.handleChange}
                type="text"
                name="owner_four"
                validations={
                  fieldInfo.percent_four ? ["required", "maxSize"] : ["maxSize"]
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputFiled
                placeholder="Split %"
                value={fieldInfo.percent_four}
                disabled={!fieldInfo.owner_four}
                //validations={fieldInfo.owner_four ? ["required"] : []}
                handleError={this.handleError}
                handleChange={this.handleChange}
                type="text"
                name="percent_four"
              />
            </Grid>
            {!this.checkSplitPercent() && (
              <FormHelperText style={{ color: "red" }}>
                Sum of split % should be equal to 100, please adjust split
                percentage.
              </FormHelperText>
            )}
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link
              className="cancelButton"
              component="button"
              onClick={this.onCancel}
            >
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isInvalid || !this.checkSplitPercent()}
              onclick={this.handleSubmit}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FieldForm;



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/Fields/FieldForm.js